module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"products":{"collection_table":{"show_in_ranking":"Peer group ranking"}}}}}}')
  delete Component.options._Ctor
}
